// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import { registerControllers } from "@radioactive-labs/plutonium"
registerControllers(application)

import MarketingNavController from "./marketing_nav_controller"
application.register("marketing-nav", MarketingNavController)

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import StopPropagationController from "./stop_propagation_controller"
application.register("stop-propagation", StopPropagationController)

import PollController from "./poll_controller"
application.register("poll", PollController)
